import { render, staticRenderFns } from "./AlterarVideo.vue?vue&type=template&id=14825b75&scoped=true"
import script from "./AlterarVideo.vue?vue&type=script&lang=js"
export * from "./AlterarVideo.vue?vue&type=script&lang=js"
import style0 from "./AlterarVideo.vue?vue&type=style&index=0&id=14825b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14825b75",
  null
  
)

export default component.exports